/** Testing: ghost guide hint in nav, no point charge, 5-move scramble → 5-step guide solves. */
export const GHOST_GUIDE_TEST_MODE = false;

/** Scramble depth when {@link GHOST_GUIDE_TEST_MODE} builds a fresh local board. */
export const GHOST_GUIDE_TEST_SCRAMBLE_MOVES = 10;
